import * as UI from "../framework/ui.js";
import * as Popup from "../framework/components/popup";

const COOKIE_NAME = "pdf_importer_dismissed_at";
const SNOOZE_DAYS = 365;
const COOKIE_MAX_AGE = SNOOZE_DAYS * 24 * 60 * 60;

UI.onDataActionClick("pdf-importer:dismiss", async ({ el }) => {
  const importerId = el.dataset.pdfImporterId;
  const confirmSelector = `#${el.dataset.pdfImporterConfirmId}`;

  if (!(await Popup.confirm(confirmSelector))) return;

  const dismissedAt = new Date().toISOString();
  document.cookie = `${COOKIE_NAME}=${dismissedAt}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax; Secure`;
  document.getElementById(importerId)?.remove();
});
